import React from 'react';
import colors from 'constants/colors';

const Link = ({ color = '$fmDefaultIcons' }) => (
    <svg viewBox={'0 0 18 18'} xmlns="http://www.w3.org/2000/svg">
        <path
            d="M5.7 15.255l2.957-2.85 1.478 1.478-3.062 2.85c-.739.74-1.689 1.161-2.639 1.161-.95 0-1.9-.422-2.64-1.16l-.633-.634C.422 15.466 0 14.41 0 13.46c0-.95.422-1.9 1.161-2.639l4.223-4.223c1.478-1.478 4.012-1.478 5.384 0l.634.634L9.924 8.71l-.634-.634c-.633-.633-1.794-.633-2.428 0L2.64 12.3c-.316.317-.528.74-.528 1.161 0 .423.212.845.528 1.162l.634.633c.739.634 1.794.634 2.428 0zM16.892 1.742c1.479 1.478 1.479 3.906 0 5.279l-4.222 4.222c-.634.74-1.69 1.162-2.64 1.162-.95 0-1.9-.423-2.639-1.162l1.478-1.478c.633.634 1.795.634 2.428 0l4.223-4.222c.633-.74.633-1.795 0-2.429l-.633-.633c-.634-.633-1.795-.633-2.429 0L9.501 5.437 8.023 3.959l2.85-2.85a3.823 3.823 0 0 1 5.385 0l.633.633z"
            fill={colors[color] ? colors[color] : '#788590'}
            fillRule="nonzero"
        />
    </svg>
);

export default Link;
